

//IMPORTANT: this file is auto-generated, any changes included will not be persisted, if extension is required please inherit from this class in separate file and inlcude your changes there

export interface IFilterModel { 
       subFleetId?: number;
       dateStart?: Date;
       dateEnd?: Date;
}

export class FilterModel implements IFilterModel {
    constructor(
        public subFleetId: number,
        public dateStart: Date,
        public dateEnd: Date
    )
    {

    }

    public static empty() {
        return new FilterModel(null, null, null);
    }
}


